const DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

const toDateString = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const isValidDateString = (value) => {
  const match = DATE_PATTERN.exec(value || "");
  if (!match) {
    return false;
  }

  const [, year, month, day] = match;
  const parsed = new Date(Number(year), Number(month) - 1, Number(day));
  return toDateString(parsed) === value;
};

export const getReservationDateLimit = ({ availableDateCount, baseDate = new Date() } = {}) => {
  if (availableDateCount === null || availableDateCount === undefined || availableDateCount === "") {
    return null;
  }

  const count = Number(availableDateCount);
  if (!Number.isFinite(count) || !(baseDate instanceof Date) || Number.isNaN(baseDate.getTime())) {
    return null;
  }

  const limit = new Date(baseDate);
  limit.setHours(0, 0, 0, 0);
  limit.setDate(limit.getDate() + Math.max(Math.trunc(count), 0));

  return toDateString(limit);
};

export const isDateWithinReservationDateLimit = (date, limit) => {
  if (!limit) {
    return true;
  }

  const parsedDate = String(date || "").slice(0, 10);
  return isValidDateString(parsedDate) && parsedDate <= limit;
};

export const formatReservationDateLimit = (limit) => {
  if (!isValidDateString(limit)) {
    return "";
  }

  const [year, month, day] = limit.split("-");
  return `${year}년 ${Number(month)}월 ${Number(day)}일`;
};
